import { Domain, currentUserVar } from "../_graphql/cache/auth";

import { RouteProps } from "./routes";
import _ from "lodash";
import config from "config";
import lodash from "lodash";
import { rankRoutes } from "react-location-rank-routes";

const appDetails = {
  Visal: {
    name: "Visal",
    logo: require("assets/logo.png"),
    hero: require("assets/hero.png"),
  },
  KEK: {
    name: "KEK",
    logo: require("assets/logo-kek-1.png"),
    hero: require("assets/hero-kek.jpg"),
  },
  Comfy: {
    name: "Company Name",
    logo: require("assets/logo-comfy.jpg"),
    hero: require("assets/hero-comfy.jpg"),
  },
};

export const getAppDetails = () => {
  const domain = getDomain();
  return appDetails[domain];
};

export const getDomain = (): Domain => {
  return config.appDomain as Domain;
};

export const withRoutePermissions = (routes: RouteProps[]) => {
  return lodash.filter(routes, () => true);
};
export const withRoutesRoles = (routes: RouteProps[]) => {
  const currentUser = currentUserVar();
  const permissions =
    JSON.parse(atob(currentUser?.user_role?.privileges || "") || "[]") || [];
  // console.log("Current User Permissions", permissions);
  return lodash.filter(routes, (route) =>
    route?.withPermissions && route?.withPermissions.length > 0
      ? lodash.intersection(route?.withPermissions, permissions || []).length >
        0
      : true
  );
};

export const withRouteDomains = (routes: RouteProps[]) => {
  const currentDomain = getDomain();

  return lodash.filter(routes, (route) =>
    route?.withDomains && route?.withDomains.length > 0
      ? route?.withDomains.includes(currentDomain as Domain)
      : true
  );
};

/**
 *
 * @param permissions permissions associated with the current user. pass this if you are using permissions
 * @returns a list of filtered routes
 */
const filterRoutes = () => {
  return lodash.flow([rankRoutes, withRouteDomains, withRoutesRoles]);
};

export default filterRoutes;
